/* eslint-disable react-hooks/exhaustive-deps */
import { cn } from "@/lib/utils";
import { useState, useEffect } from "react";

const NumberCounter = ({
  prevNumber,
  targetNumber,
  interval,
  className,
  isFloat = false,
}: {
  prevNumber: number;
  targetNumber: number;
  interval: number;
  className?: string;
  isFloat?: boolean;
}) => {
  const [currentNumber, setCurrentNumber] = useState<number>(targetNumber);

  useEffect(() => {
    let start = prevNumber;
    const end = targetNumber;
    if (start === end) return;

    const duration = 0.025; // Duration of the animation in milliseconds
    const increment = end > start ? interval : interval * -1;
    const totalSteps = Math.abs(end - start);
    const stepTime = Math.max(Math.floor(duration / totalSteps), 1);
    const timer = setInterval(() => {
      start += increment;
      setCurrentNumber(start);
      if (start === end) {
        clearInterval(timer);
      } else if (increment > 0 && start > end) {
        setCurrentNumber(end);
        clearInterval(timer);
      } else if (increment < 0 && start < end) {
        setCurrentNumber(end);
        clearInterval(timer);
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [targetNumber]);

  return (
    <div
      className={cn(
        "text-black text-2xl not-italic font-bold leading-[normal]",
        className
      )}
    >
      {isFloat
        ? currentNumber.toLocaleString()
        : Math.ceil(currentNumber)?.toLocaleString()}
    </div>
  );
};

export default NumberCounter;
